import React, { useEffect, useState } from "react";
import { ArrowUpIcon } from "@heroicons/react/24/outline";
import { Button } from "primereact/button";
import logosmall from "../assets/images/logosmall.png";
import apiFunctions from "../services/api-service";
import HomeContentView from "../components/homeBuilder/HomeContentView";

const HomePage: React.FC = () => {
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const [loading, setLoading] = useState(true);
  const [homeContent, setHomeContent] = useState<any>(null);
  const [liveVideos, setLiveVideos] = useState<any[]>([]);
  const [pageVideos, setPageVideos] = useState<any[]>([]);
  const [events, setEvents] = useState<any[]>([]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    const handleScroll = () => {
      setShowScrollToTop(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);

    // Load admin-managed dynamic content (public endpoints, no auth needed)
    apiFunctions.get("/homecontent").then((res) => {
      if (res?.data?.success) setHomeContent(res.data.data);
    }).catch(() => { }).finally(() => setLoading(false));
    apiFunctions.get("/livevideo/webapp/list").then((res) => {
      if (res?.data?.success) setLiveVideos(res.data.data || []);
    }).catch(() => { });
    apiFunctions.get("/pagevideo/webapp/list").then((res) => {
      if (res?.data?.success) setPageVideos(res.data.data || []);
    }).catch(() => { });
    apiFunctions.get("/event/webapp/list").then((res) => {
      if (res?.data?.success) setEvents(res.data.data || []);
    }).catch(() => { });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (loading) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center gap-4 bg-white z-50">
        <img src={logosmall} alt="Sagar Samaj" className="w-20 h-20" />
        <span className="text-xl font-semibold" style={{ color: "#264164" }}>Sagar Samaj</span>
        <div className="flex items-center gap-2">
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="loading-dot"
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: "#264164",
                animationDelay: `${i * 0.3}s`,
              }}
            />
          ))}
        </div>
        <style>{`
          @keyframes loadingDotBounce {
            0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
            40% { transform: scale(1); opacity: 1; }
          }
          .loading-dot {
            display: inline-block;
            animation: loadingDotBounce 2.4s ease-in-out infinite;
          }
        `}</style>
      </div>
    );
  }

  return (
    <div>
      <HomeContentView
        homeContent={homeContent}
        liveVideos={liveVideos}
        pageVideos={pageVideos}
        events={events}
        logo={logosmall}
        sticky
      />
      {showScrollToTop && (
        <Button
          onClick={scrollToTop}
          className="fixed bottom-5 right-5 bg-blue-500 text-white p-3 rounded-full shadow-lg hover:bg-blue-600 transition duration-300"
          // Explicit z-index: with no z-index, a position:fixed element's
          // stacking is just DOM order within its stacking context — the new
          // z-index:1 on section content (for the cover-image overlay
          // effect) could otherwise end up visually on top of this.
          style={{ zIndex: 1000 }}
        >
          <ArrowUpIcon style={{ width: 24, height: 24 }} />
        </Button>
      )}
    </div>
  );
};

export default HomePage;
